/**
 * Challenge-type config shared between the Challenges list page and the
 * Challenge detail page. Kept in a standalone module so both pages import
 * from one source of truth (previously it lived inside `ChallengesPage.js`
 * and detail-page splits duplicated the constants).
 */
import { Dumbbell, Clock, Flame, Calendar, Target, Droplet, Timer } from 'lucide-react';

export const CHALLENGE_TYPE_CONFIG = {
  workout_count: { icon: Dumbbell, label: 'Complete Workouts', unit: 'workouts' },
  total_minutes: { icon: Clock, label: 'Total Minutes', unit: 'minutes' },
  total_calories: { icon: Flame, label: 'Burn Calories', unit: 'calories' },
  streak: { icon: Calendar, label: 'Day Streak', unit: 'days' },
  specific_workout: { icon: Target, label: 'Category Challenge', unit: 'workouts' },
  daily_water: { icon: Droplet, label: 'Hydration', unit: 'oz' },
  daily_reps: { icon: Dumbbell, label: 'Daily Reps', unit: 'reps' },
  daily_duration: { icon: Timer, label: 'Daily Duration', unit: 'seconds' },
};

export const LOGO_URL = '/logo.webp';
